module.exports = __webpack_public_path__ + "img/au_gallery_3.c92ee760.jpg";